export enum Stage {
  IS_COLLECTING_OFFERS = 'IS_COLLECTING_OFFERS',
  IS_IN_CONVERSATION = 'IS_IN_CONVERSATION',
  IS_OFF_THE_MARKET = 'IS_OFF_THE_MARKET',
}
